"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var Cell_less_1 = __importDefault(require("./Cell.less"));
var Cell = function (_a) {
    var _b;
    var selected = _a.selected, monthInfo = _a.monthInfo, date = _a.date, items = _a.items, onClick = _a.onClick;
    var titlesRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useMemo)(function () { return [
        date.day === (selected === null || selected === void 0 ? void 0 : selected.day),
        date.day === monthInfo.today,
    ]; }, [selected, monthInfo, date]), active = _c[0], today = _c[1];
    var backgroundPoster = (0, react_1.useMemo)(function () {
        var _a, _b;
        return (_b = (_a = items.find(function (item) { return typeof item.poster === 'string' && item.poster.length > 0; })) === null || _a === void 0 ? void 0 : _a.poster) !== null && _b !== void 0 ? _b : null;
    }, [items]);
    var displayedItems = (0, react_1.useMemo)(function () {
        return items.slice(0, 4);
    }, [items]);
    var _d = (0, react_1.useState)({}), titleSizes = _d[0], setTitleSizes = _d[1];
    var onCellClick = function () {
        onClick && onClick(date);
    };
    var onInnerClick = (0, react_1.useCallback)(function (event) {
        event.stopPropagation();
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        var el = titlesRef.current;
        if (!el)
            return;
        var raf = 0;
        var measure = function () {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(function () {
                var root = titlesRef.current;
                if (!root)
                    return;
                var computed = getComputedStyle(root);
                var basePx = parseFloat(computed.getPropertyValue('--baseTitleSize')) || 18;
                var minPx = parseFloat(computed.getPropertyValue('--minTitleSize')) || 12;
                var maxPxCss = parseFloat(computed.getPropertyValue('--maxTitleSize')) || 30;
                var lineHeightFactor = parseFloat(computed.getPropertyValue('--titleLineHeight')) || 1.25;
                var sideMargin = parseFloat(computed.getPropertyValue('--titleSideMarginPx')) || 6;
                var buttons = Array.from(root.querySelectorAll('[data-fit-title="true"]'));
                var lines = buttons.length;
                if (!lines)
                    return;
                var rootRect = root.getBoundingClientRect();
                var rootPaddingTop = parseFloat(getComputedStyle(root).paddingTop) || 0;
                var rootPaddingBottom = parseFloat(getComputedStyle(root).paddingBottom) || 0;
                var rootGap = parseFloat(getComputedStyle(root).rowGap || getComputedStyle(root).gap) || 0;
                var availableHeight = Math.max(0, rootRect.height - rootPaddingTop - rootPaddingBottom);
                var maxPxByHeight = Math.floor((availableHeight - Math.max(0, lines - 1) * rootGap) / (lines * lineHeightFactor));
                var maxPx = Math.max(minPx, Math.min(maxPxCss, maxPxByHeight));
                var next = {};
                for (var _i = 0, buttons_1 = buttons; _i < buttons_1.length; _i++) {
                    var btn = buttons_1[_i];
                    var id = btn.getAttribute('data-fit-id');
                    if (!id)
                        continue;
                    var span = btn.querySelector('[data-fit-text="true"]');
                    if (!span)
                        continue;
                    span.style.fontSize = "".concat(basePx, "px");
                    var availableWidth = Math.max(0, btn.clientWidth - sideMargin * 2);
                    var textWidth = span.scrollWidth || 1;
                    var target = Math.floor(basePx * (availableWidth / textWidth));
                    next[id] = Math.max(minPx, Math.min(maxPx, target));
                }
                setTitleSizes(next);
            });
        };
        measure();
        var ro = new ResizeObserver(measure);
        ro.observe(el);
        return function () {
            cancelAnimationFrame(raf);
            ro.disconnect();
        };
    }, [displayedItems]);
    return (react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Cell_less_1.default['cell'], (_b = {},
            _b[Cell_less_1.default['active']] = active,
            _b[Cell_less_1.default['today']] = today,
            _b[Cell_less_1.default['hasPoster']] = !!backgroundPoster,
            _b)), onClick: onCellClick },
        react_1.default.createElement("div", { className: Cell_less_1.default['heading'] },
            react_1.default.createElement("div", { className: Cell_less_1.default['day'] }, date.day)),
        react_1.default.createElement("div", { className: Cell_less_1.default['content'] },
            backgroundPoster ?
                react_1.default.createElement(components_1.Image, { className: Cell_less_1.default['background'], src: backgroundPoster, alt: ' ' })
                :
                    react_1.default.createElement("div", { className: Cell_less_1.default['backgroundPlaceholder'] }),
            react_1.default.createElement("div", { className: Cell_less_1.default['titles'], onClick: onInnerClick, ref: titlesRef },
                displayedItems.map(function (_a) {
                    var id = _a.id, name = _a.name, deepLinks = _a.deepLinks;
                    return (react_1.default.createElement(components_1.Button, { key: id, className: Cell_less_1.default['titleLink'], href: deepLinks.metaDetailsStreams, "data-fit-title": true, "data-fit-id": id },
                        react_1.default.createElement("span", { className: Cell_less_1.default['titleText'], "data-fit-text": true, style: titleSizes[id] ? { fontSize: "".concat(titleSizes[id], "px") } : undefined }, name)));
                }),
                items.length > 4 ?
                    react_1.default.createElement("div", { className: Cell_less_1.default['moreCount'] },
                        "+",
                        items.length - 4,
                        " more")
                    :
                        null))));
};
exports.default = Cell;
